// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Activity from "./activity.js"
import AgendaItem from "./agenda-item.js"

const modelClassData = {
  "attributes": {
    "activity_id": {
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      },
      "name": "activity_id",
      "selected_by_default": null,
      "translated": null
    },
    "agenda_items_count": {
      "column": {
        "default": 0,
        "name": "agenda_items_count",
        "null": false,
        "type": "integer"
      },
      "name": "agenda_items_count",
      "selected_by_default": null,
      "translated": null
    },
    "date": {
      "column": {
        "default": null,
        "name": "date",
        "null": true,
        "type": "date"
      },
      "name": "date",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "show_in_live": {
      "column": {
        "default": false,
        "name": "show_in_live",
        "null": false,
        "type": "boolean"
      },
      "name": "show_in_live",
      "selected_by_default": null,
      "translated": null
    },
    "any_agenda_items_shown_in_live": {
      "column": null,
      "name": "any_agenda_items_shown_in_live",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Agenda",
  "collectionKey": "agendas",
  "collectionName": "agendas",
  "i18nKey": "agenda",
  "camelizedLower": "agenda",
  "name": "Agenda",
  "nameDasherized": "agenda",
  "pluralName": "agendas",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_id",
      "name": "agenda_items",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "current_agenda_id",
      "name": "current_for_activities",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "agenda_items_count",
      "column": {
        "default": 0,
        "name": "agenda_items_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "date",
      "column": {
        "default": null,
        "name": "date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "show_in_live",
      "column": {
        "default": false,
        "name": "show_in_live",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_id",
      "name": "agenda_items",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": null
    }
  ],
  "paramKey": "agenda",
  "primaryKey": "id"
}

/** Frontend model for Agenda. */
export default class Agenda extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  agendaItemsCount() {
    return this.readAttributeUnderscore("agenda_items_count")
  }

  /** @returns {boolean} */
  hasAgendaItemsCount() {
    const value = this.agendaItemsCount()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  date() {
    return this.readAttributeUnderscore("date")
  }

  /** @returns {boolean} */
  hasDate() {
    const value = this.date()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showInLive() {
    return this.readAttributeUnderscore("show_in_live")
  }

  /** @returns {boolean} */
  hasShowInLive() {
    const value = this.showInLive()

    return this._isPresent(value)
  }

  /** @returns {any} */
  anyAgendaItemsShownInLive() {
    return this.readAttributeUnderscore("any_agenda_items_shown_in_live")
  }

  /** @returns {boolean} */
  hasAnyAgendaItemsShownInLive() {
    const value = this.anyAgendaItemsShownInLive()

    return this._isPresent(value)
  }

  /** @returns {import("./activity.js").default | null} */
  activity() {
    return this._readBelongsToReflection({modelClass: Activity, reflectionName: "activity"})
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  loadActivity() {
    if (!("activityId" in this)) throw new Error("Foreign key method wasn't defined: activityId")

    const id = this.activityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "activity",
        model: this,
        modelClass: Activity
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  ensureActivityLoaded() {
    return this.ensureAssociationLoaded("activity")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./agenda-item.js").default>} */
  agendaItems() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["agenda_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "agenda_items",
        model: this,
        modelClass: AgendaItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item.js").default>>} */
  loadAgendaItems() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["agenda_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "agenda_items",
        model: this,
        modelClass: AgendaItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item.js").default>>} */
  ensureAgendaItemsLoaded() {
    return this.ensureAssociationLoaded("agenda_items")
  }
}
